export default "__VITE_ASSET__Bd5FEi0s__"